import { IFinancialPlanQualityData } from '../../../model/types'

export const hasFinancialPlan = (finData: IFinancialPlanQualityData[]) =>
  finData.some((row) => row.plan > 0)
